const stepStatusTypes = {
	INCOMPLETE: 'INCOMPLETE',
	IN_PROGRESS: 'IN_PROGRESS',
	COMPLETED: 'COMPLETED'
}

export default stepStatusTypes



// WEBPACK FOOTER //
// ./src/enums/stepStatusTypes.js